/**
 * Builds the origin URL for the reports subdomain SPA from the current host.
 * Local dev: `reports.localhost:5670`. Production: swaps the first subdomain to `reports`.
 * @returns Reports app origin without a trailing path.
 */
export function getReportsAppOrigin(): string {
  const { protocol, hostname, port } = window.location;
  const portSuffix = port ? `:${port}` : '';

  if (hostname === 'localhost' || hostname.endsWith('.localhost')) {
    return `${protocol}//reports.localhost${portSuffix}`;
  }

  const hostParts = hostname.split('.');
  if (hostParts.length >= 2) {
    hostParts[0] = 'reports';
    return `${protocol}//${hostParts.join('.')}${portSuffix}`;
  }

  return `${protocol}//reports.${hostname}${portSuffix}`;
}
